import config from 'constants/config'

export function isLereEnabled() {
  return config.LERE_ENABLED
}
